<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone :tbody-tr-class="rowClass">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <!--      <template v-slot:cell(contractorName)="data">-->
      <!--        <div style="color: #4caedc" @click="showDetail(data.item.contractorName)">{{ data.item.contractorName }}</div>-->
      <!--      </template>-->
      <!--      <template v-slot:cell(joinDate)="data">-->
      <!--        {{moment(data.item.joinDate).format("YYYY-MM-DD")}}-->
      <!--      </template>-->
      <!--      <template v-slot:cell(leaveDate)="data">-->
      <!--        {{-->
      <!--          (data.item.leaveDate === '' || data.item.leaveDate === undefined) ? '-' : moment(data.item.leaveDate).format("YYYY-MM-DD")-->
      <!--        }}-->
      <!--      </template>-->
      <template v-slot:cell(materDetailList)="data">
        <div>
          <div v-show="data.item.materDetailList.length > 0" style="display:flex; align-items: center; margin-bottom: 5px; width: 100%; height: 20px;">
            <div style="width: 62px;"></div>
            <div style="flex: 1; display: flex; justify-content: space-between;">
              <div style="width: 32%; text-align: center">规格</div>
              <div style="width: 35%; text-align: center">重量（斤）</div>
              <div style="width: 31%; text-align: center">数量</div>
            </div>
          </div>
          <div v-for="(key, index) in data.item.materDetailList" :key="index" style="display:flex; align-items: center; margin-bottom: 5px">
            <div style="width: 62px; padding-right: 2px;">{{key.materName}}</div>
            <div style="flex: 1; display: flex; justify-content: space-between;">
              <div style="width: 32%; color: #4caedc" @click="showDetail(key.materModel)">{{key.materModel}}</div>
              <div style="width: 35%;"> {{Number(key.materWeight).toFixed(4)}}</div>
              <div style="width: 31%;">{{key.materNum}}</div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:cell(totalWeightIncludeTrayPack)="data">
        {{ Number(data.item.totalWeightIncludeTrayPack).toFixed(2) }}
      </template>
      <template v-slot:cell(trayWeight)="data">
        {{ Number(data.item.trayWeight).toFixed(2) }}
      </template>
      <template v-slot:cell(totalWeightIncludePack)="data">
        {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
      </template>
      <template v-slot:cell(packWeight)="data">
        {{ Number(data.item.packWeight).toFixed(4) }}
      </template>
      <template v-slot:cell(packWeightTotal)="data">
        {{ Number(data.item.packWeightTotal).toFixed(4) }}
      </template>
      <template v-slot:cell(totalWeightExcludePack)="data">
        {{ Number(data.item.totalWeightExcludePack).toFixed(4) }}
      </template>
      <template v-slot:cell(packModel)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.packModel)">{{ data.item.packModel }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(laborTypeLabel)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
      </template>
      <template v-slot:foot(totalWeightIncludeTrayPack)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'totalWeightIncludeTrayPack') }}</div>
      </template>
      <template v-slot:foot(trayWeight)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'trayWeight') }}</div>
      </template>
      <template v-slot:foot(totalWeightIncludePack)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'totalWeightIncludePack') }}</div>
      </template>
      <template v-slot:foot(trunkNum)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum2(items, 'trunkNum') }}</div>
      </template>
      <template v-slot:foot(packWeightTotal)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum3(items, 'packWeightTotal') }}</div>
      </template>
      <template v-slot:foot(totalWeightExcludePack)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum3(items, 'totalWeightExcludePack') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "ItsStockFruitOutBoundSecondaryDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'totalWeightIncludeTrayPack', label: '含托盘总重（斤）', width: '130px'},
        {key: 'trayWeight', label: '托盘重量（斤/个）', width: '120px'},
        {key: 'totalWeightIncludePack', label: '含筐总重（斤）', width: '120px'},
        {key: 'trunkNum', label: '装车件数（筐）', width: '120px'},
        {key: 'packModel', label: '塑料筐规格', width: '120px'},
        {key: 'materDetailList', label: '包装物料使用详情', width: '220px'},

        {key: 'packWeight', label: '包装材料重量（斤/件）', width: '120px'},
        {key: 'packWeightTotal', label: '装车包装材料重量（斤）', width: '120px'},
        {key: 'totalWeightExcludePack', label: '不含筐总重（斤）', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum2(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum3(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
::v-deep .row-center td {
  vertical-align: middle;
}
</style>